import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    PpmStationTemperatureWidget: {
        meta: {
            i18nDescrKey: "ppm-temperature-widget",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/stationTemperatureWidget/tile.vue")
    },
    PpmPestForecastWidget: {
        meta: {
            i18nDescrKey: "pest-evolution",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/pestForecastWidget/tile.vue")
    },
    PpmPestCumulativePopulationWidget: {
        meta: {
            i18nDescrKey: "ppm-pest-cumulative-widget",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/pestCumulativePopulationWidget/tile.vue")
    },
    PpmPestSelectorWidget: {
        meta: {
            i18nDescrKey: "pest-selector",
            filters: ["farm-select-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/pestSelectorWidget/tile.vue")
    },
    PpmPlotStationMonitoring: {
        meta: {
            i18nDescrKey: "select-a-plot",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/plotStationMonitoring/tile.vue")
    },
    PpmTrapSelectorWidget: {
        meta: {
            i18nDescrKey: "trap-selector-title",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/trapSelectorWidget/tile.vue")
    },
    PpmTrapReliefsWidget: {
        meta: {
            i18nDescrKey: "trap-reliefs-title",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/trapReliefsWidget/tile.vue")
    },
    PpmTrapCapturesWidget: {
        meta: {
            i18nDescrKey: "trap-captures-title",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true
        },
        component: () => import("./components/tiles/trapCapturesWidget/tile.vue")
    },
};

export default globals;
